
      var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSms = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 25,
  width: 21,
  viewBox: "0.5 0.22 41.3 49.54"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M29.01 32.44a.97.97 0 0 1 .97-.97h.35a1.14 1.14 0 0 1 1.14 1.14q.06 6.11.03 12.38c-.02 3.81-2.07 4.89-5.68 4.76q-.04-.01-21.06-.03-4.22 0-4.23-4.51-.07-33.57 0-41.2C.55 1.07 3.01.17 5.9.22q6.07.11 19.54 0c4.65-.04 6.56 1.26 6 5.95a1.18 1.17 6 0 1-1.28 1.03l-.36-.05a.95.94-86.6 0 1-.83-.94V3.55a.8.8 0 0 0-.8-.8H4a1 1 0 0 0-1 1v42.29a1.21 1.21 0 0 0 1.21 1.21H27.8a1.21 1.21 0 0 0 1.21-1.21v-13.6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M18.79 29.49q-3.32-.06-4.5-2.76a3.16 3.08-58.9 0 1-.25-1.07q-.03-.44-.07-10.32c-.01-3.74 1.11-6.29 5.06-6.31q14.11-.05 16.98-.05c5.06.01 5.82 2.75 5.78 7.51q-.07 6.9-.07 8.01c-.01 4.34-3.02 5.17-6.95 5.02q-2.16-.07-7.43-.02a1.03 1.01-67.2 0 0-.72.3l-4.83 4.83a1.33 1.33 0 0 1-2.27-.94v-3.46a.74.74 0 0 0-.73-.74Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "var(--theme-primary, #810ea9)",
  x: -4.14,
  y: -1.12,
  transform: "rotate(-.1 24433.13 -9082.982)",
  width: 8.28,
  height: 2.24,
  rx: 1.02
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" height=\"25\" width=\"21\" viewBox=\"0.5 0.22 41.3 49.54\"> <path fill=\"var(--theme-primary, #810ea9)\" d=\"   M 29.01 32.44   A 0.97 0.97 0.0 0 1 29.98 31.47   L 30.33 31.47   A 1.14 1.14 0.0 0 1 31.47 32.61   Q 31.53 38.72 31.50 44.99   C 31.48 48.80 29.43 49.88 25.82 49.75   Q 25.78 49.74 4.76 49.72   Q 0.54 49.72 0.53 45.21   Q 0.46 11.64 0.53 4.01   C 0.55 1.07 3.01 0.17 5.90 0.22   Q 11.97 0.33 25.44 0.22   C 30.09 0.18 32.00 1.48 31.44 6.17   A 1.18 1.17 6.0 0 1 30.16 7.20   L 29.80 7.15   A 0.95 0.94 -86.6 0 1 28.97 6.21   L 28.97 3.55   A 0.80 0.80 0.0 0 0 28.17 2.75   L 4.00 2.75   A 1.00 1.00 0.0 0 0 3.00 3.75   L 3.00 46.04   A 1.21 1.21 0.0 0 0 4.21 47.25   L 27.80 47.25   A 1.21 1.21 0.0 0 0 29.01 46.04   L 29.01 32.44   Z\"></path> <path fill=\"var(--theme-primary, #810ea9)\" d=\"   M 18.79 29.49   Q 15.47 29.43 14.29 26.73   A 3.16 3.08 -58.9 0 1 14.04 25.66   Q 14.01 25.22 13.97 15.34   C 13.96 11.60 15.08 9.05 19.03 9.03   Q 33.14 8.98 36.01 8.98   C 41.07 8.99 41.83 11.73 41.79 16.49   Q 41.72 23.39 41.72 24.50   C 41.71 28.84 38.70 29.67 34.77 29.52   Q 32.61 29.45 27.34 29.50   A 1.03 1.01 -67.2 0 0 26.62 29.80   L 21.79 34.63   A 1.33 1.33 0.0 0 1 19.52 33.69   L 19.52 30.23   A 0.74 0.74 0.0 0 0 18.79 29.49   Z\"></path> <rect fill=\"var(--theme-primary, #810ea9)\" x=\"-4.14\" y=\"-1.12\" transform=\"translate(15.89,42.63) rotate(-0.1)\" width=\"8.28\" height=\"2.24\" rx=\"1.02\"></rect>    </svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/sms.4ea1d835a54326645e50d18061c61b5e.svg"),
        {
          React: SvgSms,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      